import { render, staticRenderFns } from "./bindingResult.vue?vue&type=template&id=24fd78e7&scoped=true"
import script from "./bindingResult.vue?vue&type=script&lang=js"
export * from "./bindingResult.vue?vue&type=script&lang=js"
import style0 from "./bindingResult.vue?vue&type=style&index=0&id=24fd78e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd78e7",
  null
  
)

export default component.exports